<template>
    <div>
        <div class="breadcrumb-section jarallax pixels-bg" data-jarallax data-speed="0.6">
            <div class="container text-center">
                <h1>NOS PRODUITS</h1>
                <ul>
                    <li><router-link to="/">Accueil</router-link></li>
                    <li><a href="javascript:void(0);">Nos produits</a></li>
                </ul>
            </div>
        </div>
        <div class="section-block">
            <div class="container">
                <div class="row mt-40" v-if="products != null">
                    <div class="col-md-4 col-sm-4 col-12" v-for="(product, index) in products" :key="index">
                        <div class="blog-grid">
                            <img :src="url + '/' + product.images[0].path" alt="" v-if="product.images[0] != null" width="650" height="500" style="width:650;heigth:500;">
                            <div class="blog-team-box">
                                <h6>{{ product.service.name }}</h6>
                            </div>
                            <h4>
                                <router-link :to="'/produit/' + product.slug">{{ product.name }}</router-link>
                            </h4>
                            <p v-short-description="{htmlText: product.description, count: 150}"></p>
                            <router-link :to="'/produit/' + product.slug" class="button-simple-primary mt-20">
                                Détails <i class="fas fa-arrow-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BASE_URL, API_PREFIX, API_VERSION } from '../../config/urls'
export default {
  name: 'OurProducts',
  data () {
    return {
      products: null,
      url: BASE_URL
    }
  },
  mounted () {
    this.getProducts()
  },
  methods: {
    getProducts () {
      this.$http.get(BASE_URL + API_PREFIX + API_VERSION + '/products')
        .then((response) => {
          this.products = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/OurProducts.vue